<template>
	<div class="back">
		<div class="xcontont">
			<!-- 上部分:图标 -->
			<div class="xcontont-top">
				<buyjd :crtNum='crtState'></buyjd>
			</div>
			<!-- 下部分:支付成功和按钮 -->
			<div class="xcontont-btm">
				<ul>
					<img src="../../assets/img/privacy/orderpaysuc_suc.png">
					<span>支付完成</span>
					<dt>
						<button class="btn0" @click="look()">查看订单</button>
						<button class="btn1" @click="gohome()">返回首页</button>
					</dt>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import buyjd from '../../components/buyJd.vue'
	let _self;
	export default {
		name: 'OrderPaySuc',
		data() {
			return {
				// 购物车状态
				crtState: 3,
			}
		},
		created() {
			_self=this;
		},
		methods: {
			// 返回首页
			gohome() {
				this.$router.replace({name:'Home'})
			},
			// 查看订单
			look() {
				// 定义个人中心查看组件
				localStorage.setItem('menuCurrent', 1);
				// 跳转个人中心页面
				this.$router.replace({name:'MyInfo'})
			},
		},
		// 组件
		components: {
			buyjd
		},
		// 计算
		computed: {

		},
		beforeRouteEnter(to, from, next) {
			// next();
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
		// 常用生命周期
		created() {

		},
		beforeMount() {

		},
		mounted() {
			// 滚动到头部
			window.scrollTo({
				left: 0,
				top: 0,
			});
		},
		destroyed() {

		}
	}
</script>

<style lang="scss" scoped="scoped">
	// 盒子居中
	@mixin center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	// 字体方法
	@mixin font($fs, $fw, $cl) {
		opacity: 1;
		font-size: $fs;
		font-family: Source Han Sans CN, Source Han Sans CN-Bold;
		font-weight: $fw;
		color: $cl;
	}

	.back {
		background: #ffffff;
		padding-bottom: 178px;

		.xcontont {
			width: 1200px;
			margin: 0 auto;
			font-size: 24px;
			font-weight: 400;
			text-align: left;

			// 顶部
			&-top {
				width: 100%;
				height: 146px;
			}

			// 底部
			&-btm {
				display: flex;
				align-items: center;
				display: flex;
				justify-content: center;
				margin-right: 84px;

				img {
					width: 324px;
					height: 324px;
				}

				ul {
					width: 400px;
					margin-top: 68px;
					display: flex;
					flex-flow: column;
					align-items: center;
					justify-content: space-between;
					box-sizing: border-box;

					span {
						@include font(28px, 700, #333333) margin-bottom: 50px;
					}

					dt {
						width: 100%;
						height: 36px;
						display: flex;
						justify-content: space-between;

						button {
							cursor: pointer;
						}

						.btn0 {
							width: 160px;
							height: 36px;
							background: #ffffff;
							border: 1px solid #cccccc;
							border-radius: 19px;
							@include font(16px, 400, #333333);
						}

						.btn1 {
							width: 160px;
							height: 36px;
							background: #e62129;
							border-radius: 18px;
							@include font(16px, 400, #ffffff);
						}
					}
				}

			}
		}
	}
</style>
